export enum ArticleBlockType {
  H2 = "h2",
  H3 = "h3",
  PARAGRAPH = "paragraph",
  LEAD = "lead",
  LIST = "list",
  TOOL = "tool",
  TABLE = "table",
  COMPARE = "compare",
  CALLOUT = "callout",
}

export type ArticleCompareColumn = {
  title: string;
  items: string[];
};

export type ArticleBlock =
  | { type: ArticleBlockType.H2; text: string }
  | { type: ArticleBlockType.H3; text: string }
  | { type: ArticleBlockType.PARAGRAPH; text: string }
  | { type: ArticleBlockType.LEAD; text: string }
  | { type: ArticleBlockType.LIST; items: string[] }
  | { type: ArticleBlockType.TOOL; name: string; tag: string; desc: string; limit: string }
  | { type: ArticleBlockType.TABLE; head: [string, string]; rows: [string, string][] }
  | {
      type: ArticleBlockType.COMPARE;
      bad: ArticleCompareColumn;
      good: ArticleCompareColumn;
    }
  | {
      type: ArticleBlockType.CALLOUT;
      title: string;
      text: string;
      linkLabel: string;
      linkPath: string;
    };

export type ArticleFaqItem = {
  question: string;
  answer: string;
};

export type BlogArticleLocale = {
  title: string;
  excerpt: string;
  description: string;
  ctaTitle: string;
  ctaText: string;
  body: ArticleBlock[];
  faq: ArticleFaqItem[];
};
